import { wrapProtectedRoute } from 'components/desktop/_general/ProtectedRoute/ProtectedRoute';
import Detail from 'containers/desktop/Ingredient/Detail/IngredientDetail';
import New from 'containers/desktop/Ingredient/New/IngredientNew';
import Search from 'containers/desktop/Ingredient/Search/IngredientSearch';
import PERMISSIONS from 'enums/permissions';

const BaseIngredientIdParamsName = 'baseIngredientId';
const ArchiveParamsName = 'archive';

const searchResources = [
	'allergens',
	'baseIngredientList',
	'co2Labels',
	'ingredientCategories',
	'ingredientRanges',
	'nutriScoreLabels',
	'seasons',
	'tagList',
];

const basicResources = [
	'allergens',
	'baseIngredientList',
	'erpSourceList',
	'ingredientCategories',
	'nutrientList',
	'seasons',
	'tagList',
	'unitList',
];

const routes = [
	{
		path: '/ingredient/detail/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.READINGREDIENT],
		resources: basicResources,
	},
	{
		path: '/ingredient/search',
		element: <Search />,
		permissions: [PERMISSIONS.READINGREDIENT],
		resources: searchResources,
	},
	{
		path: `/ingredient/search/:${BaseIngredientIdParamsName}`,
		element: <Search />,
		permissions: [PERMISSIONS.READINGREDIENT],
		resources: searchResources,
	},
	{
		path: `/ingredient/:${ArchiveParamsName}`,
		element: <Search />,
		permissions: [PERMISSIONS.WRITEINGREDIENT],
		resources: searchResources,
	},
	{
		path: '/ingredient/new',
		element: <New />,
		permissions: [PERMISSIONS.WRITEINGREDIENT],
		resources: basicResources,
	},
	{
		path: '/ingredient/copy/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.WRITEINGREDIENT],
	},
];

export default [...routes.map(wrapProtectedRoute)];
